import React from 'react'

const Support = () => {
    return (
        <div className="h-screen pt-[120px] max-w-[900px] mx-auto">
            <h1 className="text-2xl font-bold">Support Page</h1>
        </div>
    )
}

export default Support